export var CardAction = /*#__PURE__*/function (CardAction) {
  CardAction["DownloadAction"] = "DownloadAction";
  CardAction["PreviewAction"] = "PreviewAction";
  CardAction["ViewAction"] = "ViewAction";
  CardAction["ChangeStatusAction"] = "ChangeStatusAction";
  CardAction["FollowAction"] = "FollowAction";
  return CardAction;
}({});